import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_WARRANTY } from '../../../../services';
import { UpdateRegEditPayload } from '../../../../resources/payload';
import { openAlert } from '../../../../components/alert/hooks';

export const useUpdateRegEdit = (dataWarrantyCode) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const newWarrantyNumberCode = dataWarrantyCode.warranty?.warrantyNumberCode;
      // ถ้าในช่องรหัสรับประกันมีค่า ไม่ตรงกันกับรหัสที่ validate จาก API จะ throw error
      if(values.warrantyNumberCode != values.barcode && newWarrantyNumberCode && values.warrantyNumberCode != newWarrantyNumberCode){
        throw new Error('รหัสรับประกันไม่ตรงกัน กรุณาตรวจสอบรหัสรับประกันก่อน (Enter รหัสรับประกัน)');
      }
      if(values.warrantyNumberCode && !newWarrantyNumberCode && values.oldWarrantyNumberCode !== values.warrantyNumberCode){
        throw new Error('รหัสรับประกันไม่ตรงกัน กรุณาตรวจสอบรหัสรับประกันก่อน (Enter รหัสรับประกัน)');
      }
      const formData = new FormData();
      const payload = UpdateRegEditPayload(values);

      const appendIfExists = (key, value) => {
        if (value != null && value !== undefined) {
          formData.append(key, value);
        }
      };

      Object.entries(payload).forEach(([key, value]) => appendIfExists(key, value));

      const appendFile = (key, fileList) => {
        const file = fileList?.[0];
        appendIfExists(key, file?.originFileObj ?? file?.url);
      };

      appendFile('invImage', values.invImageUrl);
      appendFile('packageImage', values.packageImageUrl);

      const response = await POST(POST_UPDATE_WARRANTY(), formData);
      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'แก้ไขข้อมูลสำเร็จ' });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
  });
  return { mutate, loading: isPending };
};
